// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M15.764 14.636l-2.63-2.63 2.63-2.63a.8.8 0 000-1.127.802.802 0 00-1.128 0l-2.631 2.63-2.631-2.63c-.31-.31-.779-.354-1.128 0-.355.354-.3.829 0 1.128l2.63 2.63-2.63 2.63a.77.77 0 000 1.127c.32.32.818.31 1.128 0l2.63-2.63 2.632 2.63c.31.31.819.31 1.128 0a.792.792 0 000-1.128z" />
      <path d="M12 3.346c2.313 0 4.486.9 6.12 2.534A8.597 8.597 0 0120.654 12a8.597 8.597 0 01-2.534 6.12A8.597 8.597 0 0112 20.654a8.597 8.597 0 01-6.12-2.534A8.597 8.597 0 013.346 12c0-2.313.9-4.486 2.534-6.12A8.597 8.597 0 0112 3.346zM12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2z" />
    </g>
  </svg>
);

export default ActionDelete;
